import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import App from './App';
import { assertNonNull } from './utils';

const rootElement = document.getElementById('root');
assertNonNull(rootElement);

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
